// =============================================================
// VARIANCE — The Executive Command Center
// File      : AuthContext.tsx
// Location  : /home/Applications/variance/web/src/lib/AuthContext.tsx
// Owner     : VARIANCE frontend application only
// Purpose   : Provides global user session context (roles, identity).
//             Currently hardcoded to Super_Admin. Will be replaced
//             by CogniFleet AUTH (GET /api/auth/me) when ready.
// =============================================================

import { createContext, useContext, ReactNode } from 'react';

// --- TYPES ---
interface AuthContextType {
  user: { id: string; name: string; email: string } | null;
  roles: string[];
  hasRole: (role: string) => boolean;
}

// --- CONTEXT DEFINITION ---
const AuthContext = createContext<AuthContextType>({
  user: null,
  roles: [],
  hasRole: () => false,
});

// --- PROVIDER COMPONENT ---
export function AuthProvider({ children }: { children: ReactNode }) {
  // PLACEHOLDER: Hardcoded to Super_Admin for now.
  // When CogniFleet AUTH is integrated, this will be replaced by:
  // const { data } = await fetch('/api/auth/me').then(res => res.json());
  const mockUser = {
    id: 'mock-uuid',
    name: 'CEO',
    email: 'ceo@variance.com'
  };
  const mockRoles = ['Super_Admin'];

  const hasRole = (role: string) => mockRoles.includes(role);

  return (
    <AuthContext.Provider value={{ user: mockUser, roles: mockRoles, hasRole }}>
      {children}
    </AuthContext.Provider>
  );
}

// --- CUSTOM HOOK ---
export const useAuth = () => useContext(AuthContext);
